// extracted by mini-css-extract-plugin
export var button = "_cs-4";
export var hasDarkBackground = "_cs-7";
export var hasLightBackground = "_cs-6";
export var iconWrapper = "_cs-0";
export var large = "_cs-2";
export var medium = "_cs-1";
export var small = "_cs-5";
export var xsmall = "_cs-3";